import React from 'react';
import { PerspectiveType, Widget } from 'src/types';
import { WIDGET_DETAILS_BY_WIDGET_TYPE } from 'src/views/constants/widgetConstants';

interface Props {
  widget: Widget,
  perspectiveType: PerspectiveType,
  workflowId: string,
  engagementId: string,
  openModal: () => void,
  editMode?: boolean,
}

const WidgetRenderer = ({
  widget,
  perspectiveType,
  workflowId,
  engagementId,
  openModal,
  editMode,
  ...rest
}: Props) => {
  const Component = WIDGET_DETAILS_BY_WIDGET_TYPE[widget.type].renderer;

  return (
    <Component
      widget={widget}
      perspectiveType={perspectiveType}
      openModal={openModal}
      engagementId={engagementId}
      workflowId={workflowId}
      editMode={editMode}
      {...rest}
      // @ts-ignore
      {...widget.componentProps}
    />
  );
};

export default WidgetRenderer;
